var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticpaymentsdisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Automatic_payments_disabled",
    "data-name": "Automatic payments disabled",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.373,
    height: 143.538,
    viewBox: "0 0 162.373 143.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31906",
    "data-name": "Rectangle 31906",
    width: 162.373,
    height: 143.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38842",
    x: 94.524,
    y: 76.869,
    width: 59.598,
    height: 59.598,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38843",
    x: 87.018,
    y: 69.369,
    width: 73.032,
    height: 73.031,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14155",
    "data-name": "Group 14155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40627",
    "data-name": "Path 40627",
    d: "M30.962,24H25.038A1.038,1.038,0,0,1,24,22.962V1.038A1.038,1.038,0,0,1,25.038,0h5.924A1.038,1.038,0,0,1,32,1.038V22.962A1.038,1.038,0,0,1,30.962,24",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40628",
    "data-name": "Path 40628",
    d: "M104.962,24H99.038A1.038,1.038,0,0,1,98,22.962V1.038A1.038,1.038,0,0,1,99.038,0h5.924A1.038,1.038,0,0,1,106,1.038V22.962A1.038,1.038,0,0,1,104.962,24",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40629",
    "data-name": "Path 40629",
    d: "M60.108,59H42.893A.893.893,0,0,1,42,58.108V44.892A.893.893,0,0,1,42.893,44H60.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40641",
    "data-name": "Path 40641",
    d: "M60.108,59H42.893A.893.893,0,0,1,42,58.108V44.892A.893.893,0,0,1,42.893,44H60.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    transform: "translate(-27)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40630",
    "data-name": "Path 40630",
    d: "M86.108,59H68.893A.893.893,0,0,1,68,58.108V44.892A.893.893,0,0,1,68.893,44H86.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40631",
    "data-name": "Path 40631",
    d: "M113.108,59H95.893A.893.893,0,0,1,95,58.108V44.892A.893.893,0,0,1,95.893,44h17.215a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40632",
    "data-name": "Path 40632",
    d: "M60.108,82H42.893A.893.893,0,0,1,42,81.108V67.892A.893.893,0,0,1,42.893,67H60.108a.892.892,0,0,1,.892.892V81.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40633",
    "data-name": "Path 40633",
    d: "M33.108,82H15.893A.893.893,0,0,1,15,81.108V67.892A.893.893,0,0,1,15.893,67H33.108a.892.892,0,0,1,.892.892V81.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40634",
    "data-name": "Path 40634",
    d: "M33.108,104H15.893a.893.893,0,0,1-.893-.892V89.892A.893.893,0,0,1,15.893,89H33.108a.892.892,0,0,1,.892.892v13.216a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40635",
    "data-name": "Path 40635",
    d: "M60.108,104H42.893a.893.893,0,0,1-.893-.892V89.892A.893.893,0,0,1,42.893,89H60.108a.892.892,0,0,1,.892.892v13.216a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40637",
    "data-name": "Path 40637",
    d: "M79.4,112H7V36H122V60.108c.993-.064,1.991-.108,3-.108a46.646,46.646,0,0,1,5,.275V18.759A6.76,6.76,0,0,0,123.24,12H110V27.4a1.6,1.6,0,0,1-1.6,1.6H95.6A1.6,1.6,0,0,1,94,27.4V12H36V27.4A1.6,1.6,0,0,1,34.4,29H21.6A1.6,1.6,0,0,1,20,27.4V12H6.759A6.759,6.759,0,0,0,0,18.759V113.24A6.759,6.759,0,0,0,6.759,120H81.176a45.777,45.777,0,0,1-1.774-8",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40638",
    "data-name": "Path 40638",
    d: "M87,77.381V67.892A.892.892,0,0,0,86.108,67H68.892a.892.892,0,0,0-.892.892V81.107a.893.893,0,0,0,.892.893H83.754A45.978,45.978,0,0,1,87,77.381",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40639",
    "data-name": "Path 40639",
    d: "M98.616,67H95.892a.892.892,0,0,0-.892.892v1.622Q96.745,68.173,98.616,67",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40640",
    "data-name": "Path 40640",
    d: "M80.258,89H68.892a.893.893,0,0,0-.892.892v13.216a.893.893,0,0,0,.892.892h8.159a45.782,45.782,0,0,1,3.207-15",
    fill: "#3c3c3b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14156",
    "data-name": "Group 14156",
    transform: "translate(-678 -4342.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 678, 4342.16)",
    filter: "url(#Path_38842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38842-2",
    "data-name": "Path 38842",
    d: "M0,0H68.925V11.117H0Z",
    transform: "translate(96.02 126.11) rotate(-45)",
    fill: "#ce171d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 678, 4342.16)",
    filter: "url(#Path_38843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38843-2",
    "data-name": "Path 38843",
    d: "M30.016,0A30.016,30.016,0,1,1,0,30.016,30.016,30.016,0,0,1,30.016,0Z",
    transform: "translate(93.52 74.87)",
    fill: "none",
    stroke: "#ce171d",
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticpaymentsdisabled);
export default __webpack_public_path__ + "static/media/Automatic payments disabled.ab2e119cc883c799c634c575a22df957.svg";
export { ForwardRef as ReactComponent };